import { serializeStyles } from '@emotion/serialize';
import { GapUnits } from '../../types';
import { cssStringToBuilderReturnType } from '../commonUtils';
export const buildSliderStyles = _ref => {
  let {
    selectors: {
      itemSelector,
      parentSelector
    },
    horizontalGap = 10,
    horizontalGapUnit = GapUnits.px,
    sliderItemWidth = 150
  } = _ref;
  const parentCss = serializeStyles([{
    [parentSelector]: {
      display: 'flex',
      width: 'fit-content',
      height: '100%',
      gap: horizontalGap + horizontalGapUnit
    }
  }]).styles;
  const itemCss = serializeStyles([{
    [`${itemSelector}:nth-child(n)`]: {
      width: sliderItemWidth
    }
  }]).styles;
  return cssStringToBuilderReturnType(parentCss + itemCss);
};
//# sourceMappingURL=sliderBuilder.js.map